import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from "../../constant";
import axios from "axios";

/**
 * Fetch Product Details
 */
export const fetchProductDetails = createAsyncThunk('product/fetchProductDetails', async (product, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/product/${product}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        // return { product, products: res.data };
        return res.data

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});

/**
 * Search Products
 */
export const searchQ = createAsyncThunk('product/searchQ', async (query, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/search?keyword=${query}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });

        console.log("Search q", res.data)
        return res.data

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});

/**
 * Fetch Related Products by Category
 */
export const fetchRelatedProducts = createAsyncThunk('product/fetchRelatedProducts', async ({ categorySlug, currentProductId, limit = 8 }, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/${categorySlug}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });

        // Handle different response structures
        let products = [];
        if (res.data.products && Array.isArray(res.data.products)) {
            products = res.data.products;
        } else if (Array.isArray(res.data)) {
            products = res.data;
        } else if (res.data.data && Array.isArray(res.data.data)) {
            products = res.data.data;
        }

        // Filter out the current product and limit results
        const relatedProducts = products
            .filter(product => product.id !== currentProductId)
            .slice(0, limit);

        return relatedProducts;

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});
